module.exports = __webpack_public_path__ + "images/2-h_o2fd89f0219a50720de44a7202f4ccfbd.svg";